import { useCallback, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const useHoverSeriesUpdateLabel = ({
  chartRef,
}: {
  chartRef: React.RefObject<ReactApexChart & {
    chartRef?: React.RefObject<HTMLDivElement>;
  }>;
}) => {
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  const attachLegendHoverEvents = useCallback(() => {
    if (!chartRef.current?.chartRef?.current) return;

    const legendItems = chartRef.current.chartRef.current
      .querySelectorAll('.apexcharts-legend-series');

    legendItems.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        setHoverIndex(index);
      });

      item.addEventListener('mouseleave', () => {
        setHoverIndex(null);
      });
    });
  }, [chartRef]);

  const getTotalOptions = useCallback(({
    series,
    colors,
    labels,
    totalColor,
    totalLabel,
  }: {
    series: number[];
    colors: string[];
    labels: string[];
    totalColor: string;
    totalLabel: string;
  }) => {
    const formatter = () => {
      if (hoverIndex !== null) {
        return `${series[hoverIndex]}`;
      }
      return `${series.reduce((a, b) => a + b, 0)}`;
    };

    const color = hoverIndex === null ? totalColor : colors[hoverIndex];
    const label = hoverIndex === null ? totalLabel : labels[hoverIndex];

    // Needed as apex chart doesn't detect changes in functions
    const seriesHash = btoa(JSON.stringify(series));

    return {
      color,
      label,
      formatter,
      seriesHash,
    };
  }, [hoverIndex]);

  return {
    getTotalOptions,
    attachLegendHoverEvents,
  };
};

export default useHoverSeriesUpdateLabel;
